import React, { useState } from 'react';

const UploadWithCheckbox = ({ handleSubmit, record, hasChildRows }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="d-flex align-items-center">
      <i
        className="fas fa-upload mx-1 my-1 awp-img-btn"
        title="Submit"
        onClick={() => handleSubmit(record, isChecked)}
        style={{ cursor: 'pointer' }}
      ></i>
      {hasChildRows && (
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id={`uploadCheckbox-${record.id}`}
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
          <label className="form-check-label" htmlFor={`uploadCheckbox-${record.id}`}>
            Parent only
          </label>
        </div>
      )}
    </div>
  );
};

export default UploadWithCheckbox;
